module.exports = __webpack_public_path__ + "img/book.ed4e4c37.jpg";